(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apd-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.querySelector('[data-apd-hero]');
    if (!hero) return;

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Size the hero to the viewport minus whatever chrome sits above it.
    const setOffset = () => {
      const top = hero.getBoundingClientRect().top + window.scrollY;
      hero.style.setProperty('--apd-hero-offset', `${Math.max(0, Math.round(top))}px`);
    };

    setOffset();
    window.addEventListener('resize', setOffset, { passive: true });

    const headerGroup = document.querySelector('#header-group, .shopify-section-group-header-group');
    if (headerGroup && 'ResizeObserver' in window) {
      new ResizeObserver(setOffset).observe(headerGroup);
    }

    if (!reduce) {
      for (const [i, el] of hero.querySelectorAll('[data-apd-fade]').entries()) {
        el.style.transitionDelay = `${120 + i * 90}ms`;
      }
    }

    // Typewriter: type a word, hold, delete, move to the next.
    const typed = hero.querySelector('[data-apd-type]');

    if (typed) {
      const words = (typed.dataset.words || '')
        .split(',')
        .map((word) => word.trim())
        .filter(Boolean);

      const target = typed.querySelector('.apd-hero__typed-text');
      const speed = Number(typed.dataset.typeSpeed) || 90;
      const hold = Number(typed.dataset.hold) || 1750;

      // Hold the widest word's width so the button never jumps as words swap.
      const reserve = () => {
        const probe = document.createElement('span');
        probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap';
        probe.className = 'apd-hero__typed-text';
        typed.append(probe);

        let widest = 0;
        for (const word of words) {
          probe.textContent = word;
          widest = Math.max(widest, probe.getBoundingClientRect().width);
        }

        probe.remove();
        if (widest) typed.style.minWidth = `${Math.ceil(widest) + 8}px`;
      };

      if (words.length > 1 && target && !reduce) {
        reserve();
        window.addEventListener('resize', reserve, { passive: true });

        // The first word is already rendered in full, so start in the
        // deleting phase — otherwise the first tick increments past
        // word.length and the "finished typing" check never matches.
        let wordIndex = 0;
        let charIndex = words[0].length;
        let deleting = true;

        const tick = () => {
          const word = words[wordIndex];

          if (deleting) {
            charIndex -= 1;
          } else {
            charIndex += 1;
          }

          target.textContent = word.slice(0, charIndex);

          let delay = deleting ? speed * 0.5 : speed;

          if (!deleting && charIndex === word.length) {
            deleting = true;
            delay = hold;
          } else if (deleting && charIndex === 0) {
            deleting = false;
            wordIndex = (wordIndex + 1) % words.length;
            delay = speed * 2;
          }

          window.setTimeout(tick, delay);
        };

        window.setTimeout(tick, hold);
      }
    }

    requestAnimationFrame(() => {
      hero.classList.add('is-ready');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apd-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-apd-sticky]');
    if (!bar) return;

    const hero = document.querySelector('.apd-hero');
    bar.hidden = false;

    if (!hero || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(hero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
